<div class="search-select-input">
  <ng-select [items]="options" [placeholder]="placeholder" (change)="valueChanged.emit($event)" class="dropdown-v3"></ng-select>
</div>
